import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/surveys";

export const surveysApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ survey: Record<string, unknown> }>(`${BASE}/${id}`),

  create: (data: Record<string, unknown>) => apiPost<{ survey: Record<string, unknown> }>(BASE, data),

  update: (id: string, data: Record<string, unknown>) =>
    apiPut<{ survey: Record<string, unknown> }>(`${BASE}/${id}`, data),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  respond: (id: string, data: Record<string, unknown>) =>
    apiPost<{ response: Record<string, unknown> }>(`${BASE}/${id}/respond`, data),

  getResults: (id: string) => apiGet<{ results: Record<string, unknown> }>(`${BASE}/${id}/results`),
};
